export * from './Tag';
export * from './TagList';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/widgets/tags/index.ts